import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import { AuthStore } from '@store/auth.store';
import { Observable } from 'rxjs';

export type FleetRegistryBatchRowAssessment = 'NO_DUPLICATE' | 'HAS_DUPLICATE' | 'INVALID';

export interface FleetRegistryBatchRowValues {
  plateNumber: string | null;
  conductionNumber: string | null;
  vehicleMaker: string | null;
  vehicleModel: string | null;
  yearModel: string | null;
  vehicleType: string | null;
  vehicleId: string | null;
  driverFirstName: string | null;
  driverLastName: string | null;
  driverMobile: string | null;
  driverLicenseNumber: string | null;
  driverBirthdate: string | null;
}

export interface FleetRegistryBatchPreviewRow {
  rowNumber: number;
  status: FleetRegistryBatchRowAssessment;
  issues: string[];
  values: FleetRegistryBatchRowValues;
}

export interface FleetRegistryBatchPreview {
  fleetId: string;
  operatorName: string;
  fileName: string;
  allowedActiveVehicles: number;
  activeVehicles: number;
  remainingVehicles: number;
  totalRows: number;
  noDuplicateRows: number;
  hasDuplicateRows: number;
  invalidRows: number;
  /** Invalid rows whose Driver Mobile Number is not 09XXXXXXXXX (missing on older APIs). */
  invalidMobileRows?: number;
  rows: FleetRegistryBatchPreviewRow[];
}

/**
 * The file half of the batch import: the template download and the upload
 * preview are REST because the API has no GraphQL upload. Like the other
 * uploads (DashboardService.uploadPhoto), the header is the raw admin token.
 */
@Injectable({ providedIn: 'root' })
export class FleetRegistryBatchService {
  private readonly baseUrl = `${environment.apiUrl_okito_official}fleet/admin/registry-batches`;

  constructor(
    private http: HttpClient,
    private authStore: AuthStore,
  ) {}

  downloadTemplate(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/template`, {
      headers: this.headers(),
      responseType: 'blob',
    });
  }

  validate(fleetId: string, file: File): Observable<FleetRegistryBatchPreview> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<FleetRegistryBatchPreview>(
      `${this.baseUrl}/validate?fleetId=${encodeURIComponent(fleetId)}`,
      formData,
      { headers: this.headers() },
    );
  }

  private headers(): HttpHeaders {
    return new HttpHeaders().set('Authorization', `${this.authStore.currentState.token}`);
  }
}
